export const AVISO_AGUARDANDO_RETOMADA =
  'Mensagem de retomada enviada. Aguarde a resposta da pessoa para voltar a escrever por aqui.';
